import src from "IMAGE";
export default { src, width: 1207, height: 168, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/ALa2tnays7NyqKioZJ+fn1OsrKxmp6ioYqmqqmW1tbVjRNYTVjj8TtEAAAAASUVORK5CYII="};
